import React from "react";
import styled from "styled-components";
import Img from "gatsby-image";
import { AcmeCompressed, Body, Header4 } from "./typography";
import { Colors } from "./styles/Colors";
import Breakpoints from "./styles/Breakpoints";

const Wrapper = styled.div`
  margin-bottom: 40px;

  > div:first-child {
    display: flex;
    align-items: ${(props) => (props.extra ? "flex-start" : "flex-end")};

    color: ${Colors.hunter};

    margin-bottom: 28px;

    ${Header4}:first-child {
      font-size: 12px;
      line-height: 12px;
      text-transform: uppercase;
      text-align: center;

      color: ${Colors.sage};
    }

    ${Body} {
      margin-left: 12px;
      color: ${Colors.grey};

      position: relative;
      bottom: 6px;

      text-align: left;
      max-width: 256px;
    }
  }

  > div:last-child {
    padding-left: 50px;
    position: relative;

    &::before {
      content: "";

      position: absolute;

      height: 110%;
      width: 1px;

      background: ${(props) => (props.extra ? "transparent" : Colors.webGrey)};

      top: 55%;
      left: 16px;

      transform: translateY(-50%);
    }
  }

  @media ${Breakpoints.tablet} {
    display: flex;

    > div {
      flex: 1 1 50%;
    }

    > div:first-child {
      position: relative;
      align-items: center;

      &::before,
      &::after {
        content: "";

        position: absolute;

        height: 60%;
        width: 1px;

        background: ${Colors.webGrey};

        left: 16px;
      }

      &::before {
        top: -75px;
      }

      &::after {
        bottom: -75px;
      }
    }

    &:first-child > div:first-child::before {
      content: none;
    }

    &:last-child > div:first-child::after {
      content: none;
    }

    > div:last-child::before {
      content: none;
    }
  }
`;

const Number = styled.span`
  display: flex;

  align-items: center;
  justify-content: center;

  font-family: ${AcmeCompressed};
  font-weight: 600;
  font-size: 16px;
  color: ${Colors.sage};

  height: 32px;
  width: 32px;

  border: 1px solid ${Colors.sage};
  border-radius: 50%;

  margin-right: 24px;
`;

export default function HowToUseRow({ index, title, image, copy }) {
  return (
    <Wrapper extra={!!copy}>
      <div>
        {!copy && <Number>{index}</Number>}
        <Header4>{title}</Header4>
        {copy && <Body>{copy?.extraCopy}</Body>}
      </div>
      <div>
        <Img fluid={image} />
      </div>
    </Wrapper>
  );
}
